import axiosPublicClient from "../../../../axiosPublicClient"

export default async (payload) => {
    const result = await axiosPublicClient.post(`/pre-check-client-view`, payload)
    return result.data
}
